<template>
  <div>   
    <div>
      <el-row class="pdbot6 borderBot">
        <el-col :span="8">
          <el-button
        type="info"
        style="background-color: #008a2c"
        icon="el-icon-back"
        circle
        @click="goBack"
      ></el-button></el-col>
        <el-col :span="8" >
          <div class="fb f20" style="text-align: center;width: 100%;">
            <span>
              <!-- <svg class="icon svg-icon" aria-hidden="true" style="font-size: 25px;">
              <use :xlink:href="'#icon-'+infoData.icon"></use>
            </svg> -->
              <i
                class="icon iconfont"
                :class="'icon-' + infoData.icon"
                style="font-size: 30px; color: #3cba1a"
              ></i>
              {{ infoData.serviceName }}</span
            >
            <!-- <el-rate disabled v-model="score" style="float:left;"></el-rate> -->
          </div>
        </el-col>
        <el-col :span="8" class="tr">
          <el-tooltip
            :content="isFollow == 0 ? '收藏' : '取消收藏'"
            placement="bottom"
            effect="dark"
          >
            <el-button
              id="follow"
              type="success"
              @click="changefollowService"
              v-if="getUserId"
              :class="isFollow == 0 ? 'nofollow' : 'isfollow'"
              circle
              >❤</el-button
            >
          </el-tooltip>

          <el-button
            v-if="showBtn && infoData.sysUrl != null && infoData.sysUrl != ''&&!special"
            class="other"
            type="success"
            @click="verify"
            >我要办事</el-button
          >
        </el-col>
      </el-row>
    </div>
    <!-- <div @click="goBack" style="cursor: pointer; color: #008a2c">
      <el-button
        type="info"
        style="background-color: #008a2c"
        icon="el-icon-back"
        circle
      ></el-button>
      &nbsp;返回个人中心
    </div> -->
    <div style="padding: 10px 0 0 0; text-align: right" v-if="!showBtn">
      <span style="color: red">该事项不支持您办理！</span>
    </div>
    <div
      style="padding: 10px 0 0 0; text-align: right"
      v-else-if="infoData.sysUrl == '' || infoData.sysUrl == null||special"
    >
      <span style="color: red"
        >该事项暂不支持PC端办理，请点击二维码，扫描办理！</span
      >
    </div>
    <el-row :gutter="0" class="eltable" align="middle">
      <el-col :span="2">
        <div class="gridContent bggray2 fb tc">事项名称</div>
      </el-col>
      <el-col :span="10">
        <div class="gridContent">{{ infoData.serviceName }}</div>
      </el-col>
      <el-col :span="2">
        <div class="gridContent bggray2 fb tc">事项编号</div>
      </el-col>
      <el-col :span="10">
        <div class="gridContent">{{ infoData.serviceCode }}</div>
      </el-col>
      <el-col :span="2">
        <div class="gridContent bggray2 fb tc">服务类别</div>
      </el-col>
      <el-col :span="10">
        <div class="gridContent">{{ infoData.serviceTypeCN }}</div>
      </el-col>
      <el-col :span="2">
        <div class="gridContent bggray2 fb tc">收费标准</div>
      </el-col>
      <el-col :span="10">
        <div class="gridContent">{{ infoData.payStd }}</div>
      </el-col>
      <el-col :span="2">
        <div class="gridContent bggray2 fb tc">主办部门</div>
      </el-col>
      <el-col :span="10">
        <div class="gridContent">{{ infoData.mainDept }}</div>
      </el-col>
      <el-col :span="2">
        <div class="gridContent bggray2 fb tc">协办部门</div>
      </el-col>
      <el-col :span="10">
        <div class="gridContent">{{ infoData.asstDept }}</div>
      </el-col>
      <el-col :span="2">
        <div class="gridContent bggray2 fb tc">服务对象</div>
      </el-col>
      <el-col :span="10">
        <div class="gridContent">{{ infoData.useRange }}</div>
      </el-col>
      <el-col :span="2">
        <div class="gridContent bggray2 fb tc">预计时限</div>
      </el-col>
      <el-col :span="10">
        <div class="gridContent">{{ infoData.useTime }}</div>
      </el-col>
      <el-col :span="2">
        <div class="gridContent bggray2 fb tc">办理时间</div>
      </el-col>
      <el-col :span="10">
        <div class="gridContent">{{ infoData.applyTime }}</div>
      </el-col>
      <el-col :span="2">
        <div class="gridContent bggray2 fb tc">办理地点</div>
      </el-col>
      <el-col :span="10">
        <div class="gridContent">{{ infoData.applyAddress }}</div>
      </el-col>
      <el-col :span="2">
        <div class="gridContent bggray2 fb tc">联系人</div>
      </el-col>
      <el-col :span="10">
        <div class="gridContent">{{ infoData.linkman }}</div>
      </el-col>
      <el-col :span="2">
        <div class="gridContent bggray2 fb tc">咨询电话</div>
      </el-col>
      <el-col :span="10">
        <div class="gridContent">{{ infoData.phoneNo }}</div>
      </el-col>
      <el-col :span="2">
        <div
          class="gridContent bggray2 fb tc"
          style="
            height: 200px;
            display: flex;
            align-items: center;
            justify-content: center;
          "
        >
          办理方式
        </div>
      </el-col>
      <el-col :span="10">
        <div class="gridContent" style="height: 200px">
          {{ showApplyType(infoData.applyType) }}
        </div>
      </el-col>
      <el-col :span="2">
        <div
          class="gridContent bggray2 fb tc"
          style="
            height: 200px;
            display: flex;
            align-items: center;
            justify-content: center;
          "
        >
          二维码
        </div>
      </el-col>
      <el-col :span="10">
        <div
          class="gridContent"
          style="height: 200px"
          v-if="infoData.qrcode != null"
        >
          <el-image
            v-for="item in infoData.qrcode"
            :key="item.originalUrl"
            style="width: 200px; height: 200px;margin-right:10px"
            :src="fileAcquisition + item.originalUrl"
            :preview-src-list="[fileAcquisition + item.originalUrl]"
          >
          </el-image>
        </div>
        <div class="gridContent" style="height: 200px" v-else></div>
      </el-col>
      <el-col :span="2">
        <div
          class="gridContent bggray2 fb"
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            height: 80px;
          "
        >
          办理条件
        </div>
      </el-col>
      <el-col :span="22">
        <div class="gridContent" style="height: 80px; overflow: auto">
          {{ infoData.applyCond }}
        </div>
      </el-col>
      <el-col :span="2">
        <div
          class="gridContent bggray2 fb tc"
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            height: 80px;
          "
        >
          服务简介
        </div>
      </el-col>
      <el-col :span="22">
        <div class="gridContent" style="height: 80px; overflow: auto">
          {{ infoData.serviceText }}
        </div>
      </el-col>
      <el-col :span="2">
        <div
          class="gridContent bggray2 fb tc"
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            height: 80px;
          "
        >
          注意事项
        </div>
      </el-col>
      <el-col :span="22">
        <div class="gridContent" style="height: 80px; overflow: auto">
          {{ infoData.attention }}
        </div>
      </el-col>
    </el-row>
    <el-row class="mt20">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="办事流程" name="first">
          <!-- 办事流程 start  -->
          <div id="applyFlow">
            <!-- <img src="@/assets/BC575534.png"/> -->
          </div>
          <!-- 办事流程 end -->
        </el-tab-pane>
        <el-tab-pane label="所需材料" name="second">
          <div id="docs"></div>
        </el-tab-pane>
        <el-tab-pane label="文件规定" name="third">
          <div id="fileStd"></div>
        </el-tab-pane>
        <el-tab-pane label="关联事项" name="four"></el-tab-pane>
      </el-tabs>
    </el-row>
  </div>
</template>

<script>
import { uploadPath, fileAcquisition } from "@/config/net.config.js";
import {
  queryServiceInfo,
  followService,
  queryServiceIsFollow,
  getCount,
} from "@/api/serviceInfo";
import "../static/css/my.css";
import { ipURL, baseURL,jwUrl } from "@/config/net.config.js";
import { mapGetters } from "vuex";

export default {
  name: "serviceInfor",
  data() {
    return {
      isFollow: 0,
      activeName: "first",
      score: 3.7,
      infoData: [],
      ipURL: ipURL,
      baseURL: baseURL,
      showBtn: true, // 我要办事按钮是否可见,true 可见
      serviceId: "",
      url: "",
      uploadPath: uploadPath,
      fileAcquisition: fileAcquisition,
      special:false,
    };
  },
  computed: {
    ...mapGetters(["getUserId", "getUserInfo"]),
  },
  mounted() {
    this.serviceId = this.$route.query.id;
    this.getServiceInfo();
    this.getServiceIsFollow();
    this.getCount(this.serviceId);
  },
  methods: {
    showApplyType(str){
      if(str!=''&&str!=null){
        if(str.indexOf('0')>-1&&str.indexOf('1')>-1){
          return '线上+线下'
        }else if(str.indexOf('0')>-1&&str.indexOf('1')==-1){
          return '线上'
        }else{
          return '线下'
        }
      }else{
        return ''
      }

    },
    goBack() {
      if(this.$route.query.page==1){
        let select = {
          'typeid':this.$route.query.typeid,
          'objid':this.$route.query.objid,
          'departmentid':this.$route.query.departmentid,
          'mainDept':this.$route.query.mainDept
        }
        this.$router.push({path:"/serviceList",query:{...select}});
      }else{
        this.$router.push("/");
      }     
    },
    async getCount(serviceId) {
      await getCount(serviceId).then(() => {});
    },
    typeIdentity() {
      if (this.getUserId) {
        let show = "";
        if (this.infoData.f4 != "" && this.infoData.f4 != null) {
          show = this.infoData.f4.indexOf(this.getUserId);
        }
        let data = this.infoData.f2.indexOf(this.getUserInfo.userType);
        if (this.infoData.f4 != "" && this.infoData.f4 != null && show == -1) {
          this.showBtn = false;
        }
        if (data == -1) {
          this.showBtn = false;
        }
        if(this.getUserInfo.userType=='0'&&(this.serviceId=='1672903850145234945'||this.serviceId=='1672899505370578945'||this.serviceId=='1575737654584291330')){
          this.special=true
        }
        // if(this.infoData.sysUrl==null||this.infoData.sysUrl==''){
        //   this.showBtn=false
        // }
      }
    },
    // 查询是否收藏
    async getServiceIsFollow() {
      let data = await queryServiceIsFollow(this.serviceId);
      this.isFollow = data;
    },
    // 收藏/取消收藏
    async changefollowService() {
      let data = await followService(this.infoData.id);
      if (data.msgCode == 200) {
        document.getElementById("follow").blur();
        if (this.isFollow == 0) {
          this.isFollow = 1;
          this.$message({
            showClose: true,
            message: "收藏成功！",
            type: "success",
          });
        } else {
          this.isFollow = 0;
          this.$message({
            showClose: true,
            message: "取消收藏成功！",
          });
        }
      }
    },
    // 查询 服务详情信息
    async getServiceInfo() {
      const data = await queryServiceInfo(this.serviceId);
      if (data.msgCode == 0) {
        this.score = data.data.evalScore / 20;
        this.infoData = data.data;
        this.infoData.qrcode = JSON.parse(this.infoData.qrcode);
        document.getElementById("applyFlow").innerHTML = data.data.applyFlow;
        document.getElementById("docs").innerHTML = data.data.docs;
        document.getElementById("fileStd").innerHTML = data.data.fileStd;
        sessionStorage.setItem("xzztcToken", data.data.serviceSecret);
        this.typeIdentity();
      }
    },
    async verify() {
      if (this.getUserId||this.infoData.f2.indexOf('3')!=-1) {
        if (this.infoData.mysystem == "SYS3") {
          //内部系统
          if (this.infoData.sysUrl.startsWith("http")) {
            window.open(this.infoData.sysUrl, "_blank");
          } else {
            this.$router.push(this.infoData.sysUrl);
          }
        }
        else if (this.serviceId == "1575732167524495361"||this.serviceId=='1715284995202187266') {
          //jwUrl 教务系统的地址
          const oa = window.open(jwUrl, "_blank");
          setTimeout(() => {
            //this.infoData.sysUrl 需要打开的表单地址
            oa.location.href=this.infoData.sysUrl
          }, 500);
        }
        else if (this.serviceId == "1575693474063462402") {
          //
          const oa = window.open(this.infoData.sysUrl, "_blank");
          setTimeout(() => {
            //this.infoData.sysUrl 需要打开的表单地址
            oa.location.href=this.infoData.sysUrl
          }, 500);
        }
        else {
          //外部系统
          window.open(this.infoData.sysUrl, "_blank");
        }
      } else {
        window.location.href =
          this.ipURL + "/cas/login?service=" + this.baseURL + "/index";
      }
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
  },
  components: {
    // HelloWorld
  },
};
</script>
<style>
.el-tabs__item.is-active {
  color: #2c3e50 !important;
  font-weight: bold;
}

.eltable {
  border-left: 1px solid #ddd;
  margin-top: 20px;
  border-top: 1px solid #ddd;
}

.eltable .gridContent {
  padding: 10px 8px;
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  min-height: 19px;
}

.el-rate__icon {
  font-size: 28px;
}

/**我要收藏，取消收藏 按钮 样式 start */
.el-button.is-circle {
  border-radius: 50%;
  padding: 8px;
}

.isfollow {
  font-size: 20px;
  color: red;
}

.isfollow:hover {
  font-size: 20px;
  color: white;
}

.nofollow {
  font-size: 20px;
  color: white;
}

.nofollow:hover {
  font-size: 20px;
  color: red;
}

/**我要收藏，取消收藏 按钮 样式 end */

.other:hover {
  color: white;
}
</style>